import { render, staticRenderFns } from "./GhostBtn.vue?vue&type=template&id=9aafc1b8&scoped=true&lang=pug"
import script from "./GhostBtn.vue?vue&type=script&lang=js"
export * from "./GhostBtn.vue?vue&type=script&lang=js"
import style0 from "./GhostBtn.vue?vue&type=style&index=0&id=9aafc1b8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aafc1b8",
  null
  
)

export default component.exports